const sound = (e, target) => {
  const self = e.target;
  const audio = document.getElementById(target);
  const currentTime = audio.currentTime ? audio.currentTime : 0;
  e.stopPropagation();
  if (currentTime > 0) {
    resetAudio(audio);
    self.classList.remove('active');
  } else {
    // 自分以外のaudioをpauseする
    const audioItem = Array.from(document.getElementsByTagName('audio'));
    const playBtns = Array.from(document.getElementsByClassName('play_music'));
    audioItem.map(a => resetAudio(a));
    playBtns.map(p => p.classList.remove('active'));

    self.classList.add('active');
    audio.play();
  }
  audio.onended = function(){
    resetAudio(audio);
    self.classList.remove('active');
  }
}

const resetAudio = (a) => {
  a.pause();
  a.currentTime = 0;
}
